import React from 'react';
import { Spinner } from '@shopify/polaris';

const LoadingComponent = () => {
    return (
        <div style={overlayStyles}>
            <Spinner accessibilityLabel="Loading" size="large" />
        </div>
    );
};

const overlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(1px)",
    WebkitBackdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
};

export default LoadingComponent;
